import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthGuard } from '../../services/auth-guard.service';
import { DynamicFormModule } from '../shared/controls/dynamic/dynamic-form.component';
import { LoadingModule } from '../shared/controls/loading.component';
import { NotesModule } from '../shared/controls/notes.component';
import { LastUpdatedModule } from '../shared/controls/last-updated.component';

import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { SortIconCustomModule } from '../shared/controls/dynamic/sort-icon-custom.component';
import { DynamicValueModule } from '../shared/controls/dynamic/dynamic-value.component';
import { SimpleControlModule } from '../shared/controls/dynamic/simple-control.component';
import { PaginatorCustomModule } from '../shared/controls/dynamic/paginator-custom.component';
import { SearchComponent } from './search.component';
import { SearchListComponent } from './search-list.component';
import { OrderFormModule } from '../orders/order-form.component';
import { UserFormModule } from '../users/user-form.component';
import { RowToolsModule } from '../shared/controls/row-tools.component';
import { LocationFormModule } from '../locations/location-form.component';




@NgModule({
  declarations: [
    SearchComponent,
    SearchListComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TableModule,
    DynamicFormModule,
    SimpleControlModule,
    NotesModule,
    DialogModule,
    LoadingModule,
    DropdownModule,
    FormsModule,
    ButtonModule,
    LastUpdatedModule,
    SortIconCustomModule,
    PaginatorCustomModule,
    DynamicValueModule,
    OrderFormModule,
    UserFormModule,
    RowToolsModule,
    LocationFormModule,
    RouterModule.forChild([
      {
        path: '',
        component: SearchComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: SearchListComponent, canActivate: [AuthGuard] },
        ]
      }
    ])
  ],
  exports: [
    SearchListComponent,
    SearchComponent,
  ]
})
export class SearchModule { }

